import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { CommonService } from 'src/app/shared/services/common.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
import { mappingtype } from '../../mappingtype/mappingtype-popup-screen/mappingtype-popup-screen.component';
import { constants } from 'src/app/shared/common/contants';

@Component({
    selector: 'app-snapshot-popup',
    templateUrl: './snapshot-popup.component.html',
    styleUrls: ['./snapshot-popup.component.scss'],
    standalone: false
})
export class SnapshotPopupComponent implements OnInit {
    backgroundColorButton;
    FormValid: UntypedFormGroup;
    updatedData;
    uploadId;
    name;
    validation_messages: any;
    mappingtypename
    buttonName
    idColumn

    snapshotname
  constructor(private commonservice: CommonService, public dialogRef:MatDialogRef<SnapshotPopupComponent>,private validation:validationmethod,private localstorage:LocalStorageSettingsService,
        private errormessage:ErrorMessages,private spinner: NgxUiLoaderService,private snackbar:MatSnackBar, @Inject(MAT_DIALOG_DATA) public data: mappingtype, private constants:constants,private fb: UntypedFormBuilder
      ) { }

  ngOnInit(): void {
      this.buttonName = 'Save'

       this.backgroundColorButton = this.localstorage.getSettings('ColorA');
     
      this.formvalidations();
  }
formvalidations(){
      this.FormValid = new UntypedFormGroup({
        'snapshotname' : new UntypedFormControl('',[Validators.required])
      })
    }

    cancel(){
      this.dialogRef.close();
    }
     saveMethod(){
       if(!this.FormValid.valid ){
            this.validation.validateAllFormFields(this.FormValid);

      this.validation.getvalidationmessage();
       }else{
          this.dialogRef.close(this.snapshotname);
       }
      
     }
}
